
<template>
    <div class="item" style="font-size:10px;line-height: 1.2em!important;">
      <div><b>{{Dias[dia]}}</b> </div>
      <div> Aula: <b>{{aula}}</b> </div>
      <div><b>{{getHoraInicio(hora)}}-{{getHoraFin(hora)}}</b> </div>
    </div>
</template>
<script>
  export default {
    props:{
      dia: { type: String, default: ''},
      aula: { type: String, default: ''},
      hora: { type: String, default: ''}
    },
    data() {
      return {
        Dias: {
          LU: 'Lunes',   
          MA: 'Martes',   
          MI: 'Miercoles',   
          JU: 'Jueves',   
          VI: 'Viernes',   
          SA: 'Sabado',   
          DO: 'Domingo',   
        }
      }
    },
    methods: {
      getHoraInicio(text){
			  if(!text) return null;
        return this.formatHora(text.substring(0, 4));
      },
      getHoraFin(text){
			  if(!text) return null;
        return this.formatHora(text.substring(5, 9));
      },
      formatHora(text){
			  if(!text) return null;
        return `${text.substring(0, 2)}:${text.substring(2, 6)}`
      }
    }
  }
</script>

<style lang="scss" module>
@import '@design';
</style>
